import { render, staticRenderFns } from "./LiveSearchBar.vue?vue&type=template&id=98b4978c&"
import script from "./LiveSearchBar.vue?vue&type=script&lang=js&"
export * from "./LiveSearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports